import { Data } from '../../../database.schema';
import { useFetchData } from '../tournament-data';

export const useFetchTeeTimeBookingData = () => {
  return useFetchData((data: Data) => {
    return data.teeTimeBooking;
  });
};
